"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import Combobox_module_default from "../Combobox.module.mjs";
import { useComboboxContext } from "../Combobox.context.mjs";
import { useId } from "@mantine/hooks";
import { jsx, jsxs } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Combobox/ComboboxGroup/ComboboxGroup.tsx
const ComboboxGroup = factory((props) => {
	const { classNames, className, style, styles, vars, children, label, id, ...others } = useProps("ComboboxGroup", null, props);
	const ctx = useComboboxContext();
	const _id = useId(id);
	const hasLabel = label !== void 0 && label !== null && label !== false && label !== "";
	return /* @__PURE__ */ jsxs(Box, {
		role: "group",
		"aria-labelledby": hasLabel ? _id : void 0,
		...ctx.getStyles("group", {
			className,
			classNames,
			style,
			styles
		}),
		...others,
		children: [hasLabel && /* @__PURE__ */ jsx("div", {
			id: _id,
			...ctx.getStyles("groupLabel", {
				classNames,
				styles
			}),
			children: label
		}), children]
	});
});
ComboboxGroup.classes = Combobox_module_default;
ComboboxGroup.displayName = "@mantine/core/ComboboxGroup";
//#endregion
export { ComboboxGroup };

//# sourceMappingURL=ComboboxGroup.mjs.map